import React, { useState } from 'react';
import Badge from 'components/shared/Badge';
import Modal from 'ui/Modal';
import { Text, TEXT_VARIANTS } from 'ui/Typography';

const LearnMore = () => {
  const [showModal, setShowModal] = useState(false);
  const toggleModal = () => setShowModal(!showModal);
  return (
    <>
      <button
        onClick={toggleModal}
        type="button"
        tabIndex="0"
        className="u-linkBtn"
      >
        Learn More
      </button>
      <Modal
        shown={showModal}
        onDismiss={toggleModal}
        canClickAway
        className="w-40p"
        enableFloatingDismiss
      >
        <Modal.Content>
          <div className="mb-16">
            <Text variant={TEXT_VARIANTS.TITLE}>
              <span className="fz-h1">
                {t('in_person_training.event_content.follow_up_content')}
              </span>
            </Text>
            <Badge dark larger rounded className="ml-12">
              {t('common.beta')}
            </Badge>
          </div>
          <InfoContent />
        </Modal.Content>
      </Modal>
    </>
  );
};

const InfoContent = () => {
  return (
    <>
      <p>
        <Text variant={TEXT_VARIANTS.BODY_BOLD}>
          {t('in_person_training.additional_info.how_to_use_header')}:
        </Text>
      </p>
      <p>
        <Text variant={TEXT_VARIANTS.BODY}>
          {t('in_person_training.additional_info.how_to_use')}
        </Text>
      </p>
      <p>
        <Text variant={TEXT_VARIANTS.BODY_BOLD}>
          {t('in_person_training.additional_info.limitations_header')}:
        </Text>
      </p>
      <ul className="ls-n">
        <Text variant={TEXT_VARIANTS.BODY}>
          <li>
            - {t('in_person_training.additional_info.limitation_immediate')}:
          </li>
          <li>
            - {t('in_person_training.additional_info.limitation_due_date')}
          </li>
          <li>
            - {t('in_person_training.additional_info.limitation_restart')}
          </li>
        </Text>
      </ul>
    </>
  );
};

export default LearnMore;
